<template>
  <CheckFormBox :title="$t('message.DataRegistration.formData.vehicle')">
    <el-row :gutter="48">
      <!-- 車輛的註冊編號 -->
      <el-col :xs="24" :sm="24">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.registrationNo')}}：</div>
        <div class="form_value">{{data.registrationNo}}</div>
      </el-col>
    </el-row>
    <!-- 車輛的車身編號最後8個字元 -->
    <!-- <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.identificationNo')}}：</div>
        <div class="form_value">{{data.identificationNo}}</div>
    </el-col>-->
    <el-row :gutter="48">
      <!-- 發出香港保險單的保險公司名稱 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.hkInsuranceCompany')}}：</div>
        <div class="form_value">{{data.hkInsuranceCompany}}</div>
      </el-col>
      <!-- 車輛的香港保險單編號 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.hkInsuranceNo')}}：</div>
        <div class="form_value">{{data.hkInsuranceNo}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 車輛的香港保險單生效日期 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.hkInsuranceStartDate')}}：</div>
        <div class="form_value">{{data.hkInsuranceStartDate | formatDT('dd/MM/yyyy')}}</div>
      </el-col>
      <!-- 車輛的香港保險單結束日期 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.hkInsuranceEndDate')}}：</div>
        <div class="form_value">{{data.hkInsuranceEndDate | formatDT('dd/MM/yyyy')}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 車輛於內地登記車牌編號 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.mainlandRegistrationNo')}}：</div>
        <div
          class="form_value"
        >{{data.mainlandRegistrationNo ? '粤':''}}&nbsp;{{data.mainlandRegistrationNo}}</div>
      </el-col>
      <!-- 車輛的內地保險單編號 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.mainlandInsuranceNo')}}：</div>
        <div class="form_value">{{data.mainlandInsuranceNo}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 車輛的內地保險單生效日期 -->
      <el-col :xs="24" :sm="12">
        <div
          class="form_label"
        >{{$t('message.DataRegistration.Vehicle.mainlandInsuranceStartDate')}}：</div>
        <div class="form_value">{{data.mainlandInsuranceStartDate | formatDT('dd/MM/yyyy')}}</div>
      </el-col>
      <!-- 車輛的內地保險單結束日期 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Vehicle.mainlandInsuranceEndDate')}}：</div>
        <div class="form_value">{{data.mainlandInsuranceEndDate | formatDT('dd/MM/yyyy')}}</div>
      </el-col>
    </el-row>
  </CheckFormBox>
</template>

<script>
import CheckFormBox from "./CheckFormBox";
export default {
  props: ["data"],
  components: { CheckFormBox },
  data() {
    return {};
  },
  computed: {
    applicationType() {
      const serviceType = this.$store.state.serviceType;
      return serviceType == "HZMB_FIRST_PERSON" ||
        serviceType == "HZMB_FIRST_COMPANY"
        ? "FIRST"
        : "RENEW";
    },
  },
};
</script>
